import { CheckboxWithHelperText, FlexColumn } from "designSystem/index";
import React, { useState } from "react";

export default () => {
	const [checked, setChecked] = useState(false);

	const onChange = (event: object, value: boolean) => {
		setChecked(value);
	};

	return (
		<FlexColumn
			alignItems="center"
			width="100%"
		>
			<CheckboxWithHelperText 
				helperTextRes="Helper Text here"
				isChecked={checked}
				mainTextSemiBold
				onChange={onChange}
				res="Main Text here"
			/>
		</FlexColumn>
	);
};